import { useViewParam } from '../../hooks/navigation/useUrlState';
import { CampaignsAdmin } from '../outreach/CampaignsAdmin';
import { FormsAdmin } from '../outreach/FormsAdmin';
import { ListConfigsAdmin } from '../outreach/ListConfigsAdmin';
import {
  OutreachSettingsAdmin,
  TestModeBanner,
} from '../outreach/OutreachSettingsAdmin';
import { ResponsesAdmin } from '../outreach/ResponsesAdmin';
import { SendersAdmin } from '../outreach/SendersAdmin';
import { TemplatesAdmin } from '../outreach/TemplatesAdmin';
import { UnmatchedRepliesAdmin } from '../outreach/UnmatchedRepliesAdmin';
import styles from './OutreachPage.module.css';

type SubTab =
  | 'campaigns' | 'templates' | 'forms' | 'responses' | 'senders'
  | 'list-configs' | 'unmatched' | 'settings';

const SUB_TABS: { key: SubTab; label: string }[] = [
  { key: 'campaigns', label: 'Campaigns' },
  { key: 'templates', label: 'Templates' },
  { key: 'forms', label: 'Forms' },
  { key: 'responses', label: 'Responses' },
  { key: 'senders', label: 'Senders' },
  { key: 'list-configs', label: 'List configs' },
  { key: 'unmatched', label: 'Unmatched replies' },
  { key: 'settings', label: 'Settings' },
];


export function OutreachPage() {
  // Sub-tab is a which-list sub-view → push (Back-able), in the URL so it's
  // shareable + reload-stable (spec §3.1/§5.4). Validate the raw param so a
  // stale/hand-edited ?section=<garbage> falls back to campaigns instead of
  // rendering a blank panel (review F5).
  const [subTabRaw, setSubTab] = useViewParam('section', 'campaigns');
  const subTab: SubTab = SUB_TABS.some((t) => t.key === subTabRaw)
    ? (subTabRaw as SubTab)
    : 'campaigns';

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <h1 className={styles.title}>Outreach</h1>
        <span className={styles.subtitle}>Campaign engine · admin</span>
      </header>

      <TestModeBanner />

      <nav className={styles.subTabs}>
        {SUB_TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`${styles.subTab} ${
              subTab === t.key ? styles.subTabActive : ''
            }`}
            onClick={() => setSubTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {subTab === 'campaigns' && <CampaignsAdmin />}
      {subTab === 'templates' && <TemplatesAdmin />}
      {subTab === 'forms' && <FormsAdmin />}
      {subTab === 'responses' && <ResponsesAdmin />}
      {subTab === 'senders' && <SendersAdmin />}
      {subTab === 'list-configs' && <ListConfigsAdmin />}
      {subTab === 'unmatched' && <UnmatchedRepliesAdmin />}
      {subTab === 'settings' && <OutreachSettingsAdmin />}
    </div>
  );
}
